const state = {
  customers: [],
  selectedCustomer: null,
  customerFetchParams: {
    ordersYear: null,
    ordersMonth: null,
  },
  selectedCustomerMessages: [],
  selectedCustomerOrders: [],
  customerSchedule: [],
  selectedCustomerSumOfPayments: 0,
  customerPayments: [],
  customersInMonth: [],
  selectedCustomerReportsOrders: [],
  selectedCustomerAttachments: [],
  customerSchedulesByMonthAndYear: [],
};
const mutations = {
  SET_DOD_CUSTOMERS(state, customers) {
    state.customers = customers;
  },
  SET_DOD_SELECTED_CUSTOMER(state, customer) {
    state.selectedCustomer = customer;
  },
  SET_DOD_SELECTED_CUSTOMER_PAYMENT(state, payment) {
    state.selectedCustomerSumOfPayments = payment;
  },
  SET_CUSTOMER_FETCH_PARAMS(state, params) {
    for (let [key, value] of Object.entries(params)) {
      state.customerFetchParams[key] = value;
    }
  },

  SET_DOD_SELECTED_CUSTOMER_MESSAGES(state, messages) {
    state.selectedCustomerMessages = messages;
  },
  SET_DOD_SELECTED_CUSTOMER_ORDERS(state, orders) {
    state.selectedCustomerOrders = orders;
  },
  SET_DOD_SELECTED_CUSTOMER_SCHEDULE(state, customerSchedule) {
    state.customerSchedule = customerSchedule;
  },
  SET_DOD_SELECTED_CUSTOMER_PAYMENTS(state, customerPayments) {
    state.customerPayments = customerPayments;
  },
  SET_DOD_CUSTOMERS_IN_MONTH(state, customers) {
    state.customersInMonth = customers;
  },
  SET_DOD_SELECTED_CUSTOMER_REPORTS_ORDERS(state, orders) {
    state.selectedCustomerReportsOrders = orders;
  },
  SET_DOD_SELECTED_CUSTOMER_ATTACHMENTS(state, attachments) {
    state.selectedCustomerAttachments = attachments;
  },
  SET_DOD_CUSTOMER_SCHEDULES_BY_MONTH_AND_YEAR(state, schedules) {
    state.customerSchedulesByMonthAndYear = schedules;
  },
};
const getters = {
  getDodCustomers: (state) => state.customers,
  getDodSelectedCustomer: (state) => state.selectedCustomer,
  getDodCustomerFetchParams: (state) => state.customerFetchParams,
  getDodSelectedCustomerMessages: (state) => state.selectedCustomerMessages,
  getDodSelectedCustomerOrders: (state) => state.selectedCustomerOrders,
  getDodSelectedCustomerSchedule: (state) => state.customerSchedule,
  getDodSelectedCustomerSumOfPayment: (state) =>
    state.selectedCustomerSumOfPayments,
  getDodSelectedCustomerPayments: (state) => state.customerPayments,
  getDodCustomersInMonth: (state) => state.customersInMonth,
  getDodSelectedCustomerReportsOrders: (state) =>
    state.selectedCustomerReportsOrders,
  getDodSelectedCustomerAttachments: (state) =>
    state.selectedCustomerAttachments,
  getDodCustomerSchedulesByMonthAndYear: (state) =>
    state.customerSchedulesByMonthAndYear,
};

export default {
  state,
  mutations,
  getters,
};
